import { MessageCircle } from "lucide-react";
import { SITE } from "../lib/site";
import { useT } from "../lib/i18n";

export default function WhatsAppButton() {
  const { lang } = useT();
  const message = encodeURIComponent(
    "Bonjour, je souhaite obtenir un devis pour K'REUSE EXTÉRIEUR.",
  );
  const href = `https://wa.me/${SITE.whatsapp}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Contact WhatsApp"
      className="fixed bottom-6 left-6 z-40 group hidden md:flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe57] text-white rounded-full pl-4 pr-5 py-3 shadow-2xl shadow-[#25D366]/40 transition-all duration-300 hover:-translate-y-1"
    >
      <span className="relative flex items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping" />
        <MessageCircle className="w-6 h-6 relative" fill="currentColor" strokeWidth={0} />
      </span>
      <span className="hidden sm:inline font-medium text-sm">
        {lang === "en" ? "WhatsApp quote" : "Devis WhatsApp"}
      </span>
    </a>
  );
}
